import { DropdownProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: '',
  button: 'bg-transparent rounded-full border border-foreground/50 text-base text-foreground px-5 py-2 min-h-[43px]',
  buttonActive: '[&>span]:text-foreground',
  buttonPlaceholder: 'text-foreground',
  itemWrapper:
    'rounded-2xl min-w-32 mt-2 border-[0.5px] border-foreground/30 scrollbar-dark bg-surface/60 backdrop-blur-md',
  item: 'py-3 text-foreground mx-5 text-center border-b border-foreground/20 last:border-none hover:bg-foreground/25',
} as DropdownProps['classProps'];

export default classProps;
